import { render, staticRenderFns } from "./Efficacy.vue?vue&type=template&id=1b9638cf&scoped=true&"
import script from "./Efficacy.vue?vue&type=script&lang=js&"
export * from "./Efficacy.vue?vue&type=script&lang=js&"
import style0 from "./Efficacy.vue?vue&type=style&index=0&id=1b9638cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9638cf",
  null
  
)

export default component.exports